<mat-toolbar class="header-toolbar">
  <div class="row">
    <div
      *ngIf="companyId"
      class="logo-oz-cambio col d-flex gap-18 align-items-center"
    >
      <img src="assets/image/merchants/{{ merchant }}/logo-oz.svg" alt="" />

      <div
        class="title-header header-title"
        *ngIf="!router.url.includes('admin')"
      >
        <h4 class="title-pj">
          {{
            tenant === tenantService.XP_NAME
              ? "Plataforma OZ"
              : "Plataforma de câmbio"
          }}
        </h4>

        <span class="business" *ngIf="tenant === tenantService.XP_NAME"
          >for Business</span
        >
      </div>

      <div
        class="title-header header-title"
        *ngIf="router.url.includes('admin')"
      >
        <h4>Plataforma OZ</h4>

        <span class="business">Admin</span>
      </div>
    </div>

    <div
      *ngIf="individualId"
      class="logo-oz-cambio col d-flex gap-18 align-items-center"
    >
      <img src="assets/image/merchants/{{ merchant }}/logo-oz-pf.svg" alt="" />

      <div
        class="title-header header-title"
        *ngIf="!router.url.includes('admin')"
      >
        <h4 class="title-pf">
          {{
            tenant === tenantService.XP_NAME
              ? "Plataforma OZ"
              : "Plataforma de câmbio"
          }}
        </h4>

        <span class="business" *ngIf="tenant === tenantService.XP_NAME"
          >para pessoa física</span
        >
      </div>

      <div
        class="title-header header-title"
        *ngIf="router.url.includes('admin')"
      >
        <h4>Plataforma OZ</h4>

        <span class="business">Admin</span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isMobile">
    <div (click)="openMobileMenu = !openMobileMenu">
      <img width="40px" src="assets/image/hamburguer-icon.svg" alt="" />
    </div>
  </ng-container>

  <ng-container *ngIf="!isMobile">
    <div class="exit-btn">
      <div class="person-icon" [matMenuTriggerFor]="userMenu">
        <img src="assets/image/person-menu-icon.svg" alt="" />

        <img src="assets/image/arrow-down.svg" alt="" />
      </div>

      <mat-menu #userMenu="matMenu">
        <!--   <button class="btn-menu-item" mat-menu-item (click)="goToAccount()">
          <img width="24px" src="assets/image/profile-icon.svg" alt="" />
          <span>Meus dados</span>
        </button>

        <div class="d-flex justify-content-center">
          <hr />
        </div>  -->

        <ng-container *ngIf="!router.url.includes('admin')">
          <button
            class="btn-menu-item"
            mat-menu-item
            (click)="goToSavedContacts()"
          >
            <img width="24px" src="assets/image/contacts-icon.svg" alt="" />
            <span>Contatos salvos</span>
          </button>

          <div class="d-flex justify-content-center">
            <hr />
          </div>
        </ng-container>

        <button class="btn-menu-item" mat-menu-item (click)="logout()">
          <img width="24px" src="assets/image/logout-icon.svg" alt="" />

          <span>Sair</span>
        </button>
      </mat-menu>
    </div>
  </ng-container>
</mat-toolbar>

<ng-container *ngIf="isMobile">
  <ng-container *ngIf="openMobileMenu">
    <div class="mobile-container">
      <mat-nav-list class="mat-nav">
        <mat-list-item
          (click)="goToHome()"
          [ngClass]="{ 'active-link-menu': router.url.includes('/home') }"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing">Início</span>
          <img mat-list-icon src="assets/image/menu-home-icon.svg" alt="" />
        </mat-list-item>

        <ng-container *ngIf="!router.url.includes('admin')">
          <mat-list-item
            [ngClass]="{ 'active-link-menu': router.url.includes('/orders') }"
            (click)="showSubmenu = !showSubmenu"
            class="parent"
          >
            <span class="full-width" *ngIf="isExpanded || isShowing"
              >Ordens</span
            >
            <img mat-list-icon src="assets/image/menu-order-icon.svg" alt="" />

            <mat-icon
              class="menu-button"
              [ngClass]="{ rotated: showSubmenu }"
              *ngIf="isExpanded || isShowing"
              >expand_more</mat-icon
            >
          </mat-list-item>

          <ng-container *ngIf="showSubmenu">
            <div
              class="submenu"
              [ngClass]="{ expanded: showSubmenu }"
              *ngIf="isShowing || isExpanded"
            >
              <a mat-list-item (click)="goToOutbound()"
                ><span>Enviar (Outbound)</span></a
              >
              <a mat-list-item (click)="goToInbound()"
                ><span>Receber (Inbound)</span></a
              >
            </div>
          </ng-container>

          <!--   <mat-list-item
          (click)="goToAccount()"
          [ngClass]="{ 'active-link-menu': router.url.includes('/account') }"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Meus Dados</span
          >
          <img mat-list-icon src="assets/image/profile-icon.svg" alt="" />
        </mat-list-item>  -->

          <mat-list-item
            (click)="goToSavedContacts()"
            [ngClass]="{
              'active-link-menu': router.url.includes('/saved-contacts')
            }"
          >
            <span class="full-width" *ngIf="isExpanded || isShowing"
              >Contatos salvos</span
            >
            <img mat-list-icon src="assets/image/contacts-icon.svg" alt="" />
          </mat-list-item>
        </ng-container>

        <mat-list-item (click)="logout()">
          <span class="full-width" *ngIf="isExpanded || isShowing">Sair</span>
          <img mat-list-icon src="assets/image/logout-icon.svg" alt="" />
        </mat-list-item>
      </mat-nav-list>
    </div>
  </ng-container>
</ng-container>

<mat-sidenav-container autosize>
  <mat-sidenav
    *ngIf="showMenu"
    [ngClass]="isExpanded ? 'padding-sidenav' : ''"
    #sidenav
    class="sidenav"
    mode="side"
    opened="true"
  >
    <div
      [ngClass]="isExpanded ? 'end-icon' : 'center-icon'"
      class="d-flex mg-top-10"
    >
      <img
        *ngIf="!isExpanded"
        (click)="isExpanded = !isExpanded"
        mat-list-icon
        src="assets/image/arrow-right-icon.svg"
        alt=""
      />
      <img
        *ngIf="isExpanded"
        (click)="isExpanded = !isExpanded"
        mat-list-icon
        src="assets/image/menu-arrow-icon.svg"
        alt=""
      />
    </div>
    <ng-container *ngIf="!router.url.includes('admin')">
      <mat-nav-list class="mat-nav">
        <mat-list-item
          (click)="goToHome()"
          [ngClass]="{ 'active-link-menu': router.url.includes('/home') }"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing">Início</span>
          <img mat-list-icon src="assets/image/menu-home-icon.svg" alt="" />
        </mat-list-item>

        <mat-list-item
          [ngClass]="{ 'active-link-menu': router.url.includes('/orders') }"
          (click)="showSubmenu = !showSubmenu"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing">Ordens</span>
          <img mat-list-icon src="assets/image/menu-order-icon.svg" alt="" />

          <mat-icon
            class="menu-button"
            [ngClass]="{ rotated: showSubmenu }"
            *ngIf="isExpanded || isShowing"
            >expand_more</mat-icon
          >
        </mat-list-item>
        <div
          class="submenu"
          [ngClass]="{ expanded: showSubmenu }"
          *ngIf="isShowing || isExpanded"
        >
          <a mat-list-item (click)="goToOutbound()"
            ><span>Enviar (Outbound)</span></a
          >
          <a mat-list-item (click)="goToInbound()"
            ><span>Receber (Inbound)</span></a
          >
        </div>
      </mat-nav-list>
    </ng-container>
    <ng-container *ngIf="router.url.includes('admin')">
      <mat-nav-list class="mat-nav">
        <!-- Menu Enviar -->
        <mat-list-item
          (click)="showSubmenuEnviar = !showSubmenuEnviar"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing">Enviar</span>
          <img mat-list-icon src="assets/image/menu-outbound-icon.svg" alt="" />
          <mat-icon
            class="menu-button"
            [ngClass]="{ rotated: showSubmenuEnviar }"
            *ngIf="isExpanded || isShowing"
            >expand_more</mat-icon
          >
        </mat-list-item>
        <div
          class="submenu"
          [ngClass]="{ expanded: showSubmenuEnviar }"
          *ngIf="showSubmenuEnviar"
        >
          <a
            mat-list-item
            (click)="goToOutboundAdmin()"
            [ngClass]="{ 'active-submenu': isActiveOutboundEmAndamento() }"
          >
            <span>Em andamento</span>
          </a>
          <a
            mat-list-item
            (click)="goToOutboundAdminPendencia()"
            [ngClass]="{ 'active-submenu': isActiveOutboundPendencia() }"
          >
            <span>Com pendência</span>
          </a>
        </div>

        <!-- Menu Receber -->
        <mat-list-item
          (click)="showSubmenuReceber = !showSubmenuReceber"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Receber</span
          >
          <img mat-list-icon src="assets/image/menu-inbound-icon.svg" alt="" />
          <mat-icon
            class="menu-button"
            [ngClass]="{ rotated: showSubmenuReceber }"
            *ngIf="isExpanded || isShowing"
            >expand_more</mat-icon
          >
        </mat-list-item>
        <div
          class="submenu"
          [ngClass]="{ expanded: showSubmenuReceber }"
          *ngIf="showSubmenuReceber"
        >
          <a
            mat-list-item
            (click)="goToInboundAdmin()"
            [ngClass]="{ 'active-submenu': isActiveInboundEmAndamento() }"
          >
            <span>Em andamento</span>
          </a>
          <a
            mat-list-item
            (click)="goToInboundAdminPendencia()"
            [ngClass]="{ 'active-submenu': isActiveInboundPendencia() }"
          >
            <span>Com pendência</span>
          </a>
        </div>

        <mat-list-item
          (click)="goToOrdersHistory()"
          [ngClass]="{
            'active-link-menu': router.url.includes('/orders-history')
          }"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Histórico de ordens</span
          >
          <img
            mat-list-icon
            src="assets/image/menu-orders-history.svg"
            alt=""
          />
        </mat-list-item>

        <mat-list-item
          (click)="goToClients()"
          [ngClass]="{
            'active-link-menu': router.url === '/' + tenant + '/admin/clients'
          }"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Gestão de clientes</span
          >
          <img mat-list-icon src="assets/image/menu-clients-icon.svg" alt="" />
        </mat-list-item>

        <mat-list-item
          (click)="goToPartnerDocuments()"
          [ngClass]="{
            'active-link-menu':
              router.url === '/' + tenant + '/admin/clients/partner-document'
          }"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Importação de arquivo</span
          >
          <img mat-list-icon src="assets/image/menu-import-icon.svg" alt="" />
        </mat-list-item>

        <mat-list-item
          (click)="goToPartners()"
          [ngClass]="{
            'active-link-menu': router.url === '/' + tenant + '/admin/partners'
          }"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Gestão de parceiros</span
          >
          <img mat-list-icon src="assets/image/menu-partners-icon.svg" alt="" />
        </mat-list-item>

        <mat-list-item
          (click)="goToManageQuotation()"
          [ngClass]="{
            'active-link-menu':
              router.url === '/' + tenant + '/admin/manage-quotation'
          }"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Gestão da cotação</span
          >
          <img
            mat-list-icon
            src="assets/image/menu-quotation-icon.svg"
            alt=""
          />
        </mat-list-item>
      </mat-nav-list>
    </ng-container>

    <mat-nav-list> </mat-nav-list>

    <div class="side-footer" *ngIf="isExpanded || isShowing">
      <div class="user-info">
        <div class="photo"></div>
        <div class="text">
          <div class="name">{{ user?.firstName }}</div>
          <div class="name">
            {{
              user?.document
                | mask
                  : (user?.document?.length === 11
                      ? "000.000.000-00"
                      : "AA.AAA.AAA/AAAA-00")
            }}
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav>

  <div class="sidenav-content">
    <ng-content></ng-content>
  </div>
</mat-sidenav-container>
